import { render } from "./AssignmentQestions.vue?vue&type=template&id=0b68bbc4&scoped=true"
import script from "./AssignmentQestions.vue?vue&type=script&lang=js"
export * from "./AssignmentQestions.vue?vue&type=script&lang=js"

import "./AssignmentQestions.vue?vue&type=style&index=0&id=0b68bbc4&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b68bbc4"]])

export default __exports__